import {
  COMPANY_CONTRACT_FETCHING,
  COMPANY_CONTRACT_FAILED,
  COMPANY_CONTRACT_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case COMPANY_CONTRACT_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case COMPANY_CONTRACT_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case COMPANY_CONTRACT_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
